import { Check, Clock, X } from 'lucide-react'
import { Badge } from '@/components/sv/badge'

type Props = {
  status: 'SUCCESS' | 'FAILED' | 'PENDING'
  responseStatus?: number | null | string
}

export const EventDeliveryStatus = ({ status, responseStatus }: Props) => {
  if (status === 'SUCCESS') {
    return (
      <Badge variant="emerald" className="font-mono">
        <Check aria-hidden="true" /> {responseStatus}
      </Badge>
    )
  }
  if (status === 'FAILED') {
    return (
      <Badge variant="destructive" className="font-mono">
        <X aria-hidden="true" /> {responseStatus}
      </Badge>
    )
  }
  if (status === 'PENDING') {
    return (
      <Badge variant="outline" className="font-mono">
        <Clock aria-hidden="true" /> Pending
      </Badge>
    )
  }
}
